import { ENTITY_GROUPS } from '@quadro/domain';
import { useEntities } from '../shared/useMap';

/** <option>s das entidades do mapa, agrupadas por tipo. */
export function EntityOptions({ empty }: { empty?: [string, string] }) {
  const { list } = useEntities();
  return (
    <>
      {empty && <option value={empty[0]}>{empty[1]}</option>}
      {ENTITY_GROUPS.map(([type, name]) => {
        const g = list.filter(n => n.tipo === type);
        if (!g.length) return null;
        return <optgroup key={type} label={name}>{g.map(n => <option key={n.id} value={n.id}>{n.curto ? `${n.curto} (${n.t})` : n.t}</option>)}</optgroup>;
      })}
    </>
  );
}
